module.exports = __webpack_public_path__ + "media/images/pc/items/album/original-6f053dc6773d6f37c6b9a622acc92738.jpg";